import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import * as actions from "./actions";

const state = {
  url: "https://portal-backend.ayegrupo.com/api",
  //url: "http://localhost:9202/api",
  user: {
    id: null,
    name: null,
    rol_id: null,
    role_name: null,
    login: null,
  },
  token: null,
  roles: [],
};

const getters = {
  get_user(state) {
    return state.user;
  },
  get_token(state) {
    return state.token;
  },
  get_roles(state) {
    return state.roles;
  }
};

const mutations = {
  mt_set_auth(state, payload) {
    state.user.id = payload.id;
    state.user.name = payload.name;
    state.user.login = payload.login
  },
  mt_set_rol(state, payload) {
    state.user.rol_id = payload.rol_id;
    state.user.role_name = payload.rol.roles;
  },
  mt_set_token(state, payload) {
    state.token = payload;
  },
  mt_set_roles(state, payload) {
    state.roles = payload;
  },
  mt_set_login(state, payload) {
    state.user.login = payload;
  },
  mt_logout_auth(state) {
    state.user = {
      id: null,
      name: null,
      rol_id: null,
      role_name: null,
      login: null,
    }
    state.token = null,
      state.roles = []
  }

};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
});